import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import PlayerScrubber from '../scrubber/PlayerScrubber'

import "./PlayerVolume.css";

export default class VolumeBar extends PureComponent {

	static propTypes = {
		volume: PropTypes.number.isRequired,
		handleVolumeUpdate: PropTypes.func.isRequired
	}
	
	static defaultProps = {
		volume: 0.75,
		handleVolumeUpdate: () => {}
	}

	constructor(props) {
		
		super(props)
		this.onMouseDown = this.onMouseDown.bind(this)
		this.onWindowMouseUp = this.onWindowMouseUp.bind(this)
		this.onWindowMouseMove = this.onWindowMouseMove.bind(this)
		this.onWindowMouseCancel = this.onWindowMouseCancel.bind(this)

	}

	componentWillUnmount() {
		this.removeWindowListeners()
	}

	onMouseDown() {
		window.addEventListener('mousemove', this.onWindowMouseMove)
		window.addEventListener('mouseup', this.onWindowMouseUp)
		window.addEventListener('dragstart', this.onWindowMouseCancel)
	}

	onWindowMouseUp(e) {
		this.updateMouseOffset(e.clientX)
		this.removeWindowListeners()
	}

	onWindowMouseCancel() {
		this.removeWindowListeners()
	}

	onWindowMouseMove(e) {
		this.updateMouseOffset(e.clientX)
	}

	updateMouseOffset(x) {
		var rect = this.el.getBoundingClientRect()
		let volume = (Math.min(rect.width, Math.max(0, x - rect.left))) / rect.width
		this.props.handleVolumeUpdate(volume)
	}

	removeWindowListeners() {
		window.removeEventListener('mousemove', this.onWindowMouseMove)
		window.removeEventListener('mouseup', this.onWindowMouseUp)
		window.removeEventListener('dragstart', this.onWindowMouseCancel)
	}

	render() {
		return (
			<div
				ref={ el => this.el = el }
				onMouseDown={ this.onMouseDown }
				className="player__volume"
				>
		 		<div className="player__volume__background">
					<div 
						className="player__volume__foreground" 
						style={{width: `${~~(this.props.volume * 100)}%`}} 
						>
						<PlayerScrubber />
					</div>
				</div>
		 	</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/player/controls/volume/PlayerVolume.jsx